import React from "react";
import { Col, Input, Button, Select } from "antd";
import { PlusOutlined, SearchOutlined } from "@ant-design/icons";
import { TitleContainer } from "./elements";
import { staffUserTypes } from "../../../utils/constants";

const { Option } = Select;

interface Location {
  id: string;
  name: string;
}

interface TableTitleProps {
  setSearchFilter: (value: string) => void;
  setTypeFilter: (value: string) => void;
  setLocationFilter: (value: string | null) => void;
  setLocationSearch: (value: string) => void;
  locations: Location[];
  loadingLocations: boolean;
  setShowCreateModal: (value: boolean) => void;
}

const TableTitle: React.FC<TableTitleProps> = ({
  setSearchFilter,
  setTypeFilter,
  setLocationFilter,
  setLocationSearch,
  locations,
  loadingLocations,
  setShowCreateModal,
}) => {
  return (
    <div>
      <TitleContainer>
        <Col
          span={24}
          style={{
            display: "flex",
            alignItems: "center",
          }}
        >
          <div style={{ display: "flex",
            gap: "10px",
            flexGrow: 1 }}>
            <Input
              style={{ width: 280 }}
              placeholder="Buscar por nombre o correo"
              prefix={<SearchOutlined style={{ color: "#bfbfbf" }} />}
              allowClear
              onChange={(e) => setSearchFilter(e.target.value)}
            />
            <Select
              style={{ width: 180 }}
              placeholder="Tipo de usuario"
              allowClear
              onChange={(value) => setTypeFilter(value)}
            >
              {Object.keys(staffUserTypes).map((key) => (
                <Option key={key} value={key}>
                  {staffUserTypes[key as keyof typeof staffUserTypes].name}
                </Option>
              ))}
            </Select>
            <Select
              showSearch
              style={{ width: 200 }}
              placeholder="Franquicia"
              filterOption={false}
              onSearch={(value) => setLocationSearch(value)}
              onSelect={(value) => setLocationFilter(value as string)}
              onClear={() => {
                setLocationFilter(null);
                setLocationSearch("");
              }}
              allowClear
              loading={loadingLocations}
            >
              {locations.map((loc) => (
                <Option key={loc.id} value={loc.id}>
                  {loc.name}
                </Option>
              ))}
            </Select>
          </div>
          <div style={{ marginLeft: "auto" }}>
            <Button
              type="primary"
              icon={<PlusOutlined />}
              onClick={() => setShowCreateModal(true)}
            >
              Crear Usuario
            </Button>
          </div>
        </Col>
      </TitleContainer>
    </div>
  );
};

export default TableTitle;
